import template from './swag-cms-extensions-custom-form-element-email.html.twig';

export default {
    template,
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
    computed: {
        displayValue() {
            return this.field.translated?.placeholder ?? this.field.placeholder ?? 'shopware@example.com';
        }
    },
}
